import { styled } from '@clickcease/cc-client-components-lib'
const regularTextCss = {
  color: '$black',
  fontSize: '$md',
  fontWeight: '$r',
}

export const DetailsBox = styled('div', {
  display: 'flex',
  width: '448px',
  maxHeight: '100%',
  flexDirection: 'column',
  gap: '$8',
  padding: '$8',
  marginBottom: '$12',
  borderRadius: '$normal',
  border: '1px solid $lightGray',
  boxShadow: '$card',
})

export const BoxRow = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
})

export const BoxRowTitle = styled('span', {
  fontSize: '$h5',
  fontWeight: '$sb',
  color: '$black',
})

export const BoxRowItem = styled('span', {
  ...regularTextCss,

  variants: {
    bold: {
      true: {
        fontWeight: '$sb',
      },
    },
    small: {
      true: {
        fontSize: '$sm',
      },
    },
    block: {
      true: {
        display: 'block',
      },
    },
    alignTop: {
      true: {
        alignSelf: 'flex-start',
      },
    },
    green: {
      true: {
        color: '$success',
      },
    },
  },
})

export const DiscountText = styled('div', {
  ...regularTextCss,
  display: 'flex',
  alignItems: 'center',
  gap: '$2',
  padding: '$2 $4',
  color: '$success',
  borderRadius: '$normal',
  backgroundColor: '$successLighter',

  span: {
    display: 'flex',
    color: '$success',
  },
})

export const DividerLine = styled('div', {
  width: '100%',
  height: '1px',
  backgroundColor: '$lightGray',
})

export const SupportText = styled('div', {
  ...regularTextCss,

  variants: {
    first: {
      true: {
        marginBottom: '$3',
      },
    },
  },
})
export const StyledLink = styled('a', {
  ...regularTextCss,
  color: '$primaryColor',
  textDecoration: 'underline',
  cursor: 'pointer',
})
